'use client';

import { ChatSidebarWork } from '@/app-shell/layout/Navigation/ChatSidebarWork';
import { useChatSidebarHandlers } from '@/app-shell/layout/Navigation/hooks/useChatSidebarHandlers';
import { ChatSidebar } from '@/components/chat/components/ChatSidebar';
import { useQueryChats } from '@/hooks/query/useQueryChats';
import { memo } from 'react';
import { EvidenceSidebarSkeleton } from './evidence-sidebar-skeleton';

/**
 * Wrapper component that shows a skeleton while chats data loads.
 * Provides instant visual feedback for perceived performance.
 *
 * Uses the chat sidebar in embedded mode to match the desktop chat sidebar design.
 */
export const EvidenceContentLoader = memo(function EvidenceContentLoader() {
  const { currentChatId, handleSelectChat, handleNewChat, handleDeleteChat } =
    useChatSidebarHandlers();
  const { isLoading } = useQueryChats();

  if (isLoading) {
    return <EvidenceSidebarSkeleton />;
  }

  return (
    <ChatSidebarWork>
      {(work) => (
        <ChatSidebar
          forceOpen
          embedded
          onSelectChat={handleSelectChat}
          onNewChat={handleNewChat}
          onDeleteChat={handleDeleteChat}
          currentChatId={currentChatId}
          work={work}
        />
      )}
    </ChatSidebarWork>
  );
});
